import { LocalStorageKey } from '../../dashboard/enums/local-storage-key.enum';
import { Locale } from '../../dashboard/enums/locale.enum';
import { DateLocationContent, dateLocationContents } from './date-location.content';

export interface DashboardContent {
  dateLocation: DateLocationContent;
  title: string;
}

type DashboardContents = { [P in Locale]: DashboardContent };

export const dashboardContents: DashboardContents = {
  [Locale.English]: {
    dateLocation: dateLocationContents[Locale.English],
    title: localStorage.getItem(LocalStorageKey.Title_en)
      ? `${localStorage.getItem(LocalStorageKey.Title_en)}`
      : 'Hi, EA Korea. Have a good day!',
  },
  [Locale.Korean]: {
    dateLocation: dateLocationContents[Locale.Korean],
    title: localStorage.getItem(LocalStorageKey.Title_ko)
      ? `${localStorage.getItem(LocalStorageKey.Title_ko)}`
      : 'Hi, EA Korea. Have a good day!',
  },
};



// WEBPACK FOOTER //
// ./src/app/assets/contents/dashboard.content.ts